import React, { FC } from 'react'

const Scale: FC = () => {
  const test = ""
  return (
    <div
      style={{
        position: "relative",
      }}
    >
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "0",
        }}
      >
        0
      </div>
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "20%",
          transform: "translateX(-50%)",
        }}
      >
        20
      </div>
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "40%",
          transform: "translateX(-50%)",
        }}
      >
        40
      </div>
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "60%",
          transform: "translateX(-50%)",
        }}
      >
        60
      </div>
      <div
        style={{
          position: "absolute",
          top: "0",
          left: "80%",
          transform: "translateX(-50%)",
        }}
      >
        80
      </div>
      <div
        style={{
          position: "absolute",
          top: "0",
          right: "0",
        }}
      >
        100
      </div>
    </div>
  )
}

export default Scale
